export default __webpack_public_path__ + "static/media/facility-area-icon.aa2b7e82.svg";